module.exports = __webpack_public_path__ + "static/media/read-chat.6b54dfa8.svg";